// Booking link used by all "Book Your Free Assessment" CTAs.
export const CALENDLY_URL = "https://calendly.com/ramon-govea/introductory-call";

export const NAV_LINKS = [
  { label: "Services", href: "#services", testId: "nav-link-services" },
  { label: "Work", href: "#work", testId: "nav-link-work" },
  { label: "About", href: "#about", testId: "nav-link-about" },
  { label: "Contact", href: "#contact", testId: "nav-link-contact" },
];
